export function apiBaseUrl () {
  return process.env.VUE_APP_API_BASE_URL
}

export function mapsApiKey() {
  return process.env.VUE_APP_MAPS_API_KEY
}

export function baseUrlReports() {
  return process.env.VUE_APP_URL_REPORTS
}